import { createRef, useEffect, useState } from 'react'
import clsx from 'clsx'

import styles from './Tabs.module.scss'

interface Props {
    options: { label: string; value: any }[]
    onChange: <T>(type: T) => void
}

export const Tabs = ({ options, onChange }: Props) => {
    const [active, setActive] = useState(options.at(0)?.value)
    const [activeIndex, setActiveIndex] = useState(-1)
    const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 })
    const refs = options.map(() => createRef<HTMLButtonElement>())

    const handleSetActive = (type: any, index: number) => {
        setActiveIndex(index)
        setActive(type)
        onChange(type)
    }

    useEffect(() => {
        if (activeIndex === -1) {
            return
        }

        const ref: React.RefObject<HTMLButtonElement> = refs[activeIndex]

        if (ref.current) {
            const { offsetLeft, offsetWidth } = ref.current
            setHighlightStyle({ left: offsetLeft, width: offsetWidth })
        }
    }, [activeIndex])

    useEffect(() => {
        requestAnimationFrame(() => {
            setActiveIndex(0)
        })
    }, [options])

    return (
        <div className={styles.tabsContainer}>
            {options.map(({ label, value }, index) => (
                <button
                    key={index}
                    ref={refs[index]}
                    onClick={() => handleSetActive(value, index)}
                    className={clsx(styles.tab, { [styles.tabActive]: active === value })}
                >
                    {label}
                </button>
            ))}
            <div
                className={styles.tabHighlight}
                style={{
                    left: highlightStyle.left,
                    width: highlightStyle.width,
                }}
            />
        </div>
    )
}
